export enum UserSuperRoles {
  Admin = 'Admin',
  Instructor = 'Instructor',
}

export enum PendoGuideNames {
  RESOURCE_CENTER = 'Resource Center',
}
